import * as React from 'react'

// Breakpoint values from tailwind.config.ts
const BREAKPOINTS = {
  sm: 540,
  md: 720,
  lg: 1040,
  xl: 1200
}

export function useBreakpoints() {
  const [breakpoints, setBreakpoints] = React.useState({
    isSm: false,
    isMd: false,
    isLg: false,
    isXl: false,
    isReady: false
  })

  React.useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth
      setBreakpoints({
        isSm: width >= BREAKPOINTS.sm,
        isMd: width >= BREAKPOINTS.md,
        isLg: width >= BREAKPOINTS.lg,
        isXl: width >= BREAKPOINTS.xl,
        isReady: true
      })
    }

    // Initial check
    handleResize()

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return breakpoints
}
